import React from "react";

const DonationConfirmation = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        
        <h1 style={styles.heading}>Thank You for Your Donation!</h1>
        <p style={styles.text}>Your contribution has been successfully received.</p>
        <p style={styles.text}>We'll send you a confirmation email shortly.</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f9fafa",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem 3rem",
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "450px",
  },
  icon: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  heading: {
    fontSize: "1.8rem",
    margin: "0 0 1rem 0",
    color: "#333",
  },
  text: {
    fontSize: "1rem",
    color: "#555",
    margin: "0.3rem 0",
  },
};

export default DonationConfirmation;
